import { useEffect } from 'react';
import { isEditableElement } from '../utils/canvasUtils';

// Хук для управления клавиатурными сокращениями
export const useKeyboardShortcuts = ({
    deleteSelectedElements,
    selectAll,
    copyElements,
    pasteElements,
    cutElements,
    elements,
    selectedElementIds,
    selectedElementId,
    setShowCodePanel,
    recordHistory,
    setElements,
    setTool, // новый проп
    onSaveDiagram, // добавляем новый проп для сохранения
    onUndo, // добавляем undo
    onRedo  // добавляем redo
}) => {
    useEffect(() => {
        const onKeyDown = (e) => {
            if (isEditableElement(e.target)) return;

            const key = (e.key || '').toLowerCase();

            // Undo (Ctrl/Cmd + Z)
            if ((e.metaKey || e.ctrlKey) && !e.shiftKey && key === 'z') {
                e.preventDefault();
                if (onUndo) {
                    onUndo();
                }
                return;
            }

            // Redo (Ctrl/Cmd + Shift + Z)
            if ((e.metaKey || e.ctrlKey) && e.shiftKey && key === 'z') {
                e.preventDefault();
                if (onRedo) {
                    onRedo();
                }
                return;
            }

            // Сохранение диаграммы (Ctrl/Cmd + S)
            if ((e.metaKey || e.ctrlKey) && key === 's') {
                e.preventDefault();
                if (onSaveDiagram) {
                    onSaveDiagram();
                }
                return;
            }

            // Переключение инструментов без модификаторов
            if (!e.metaKey && !e.ctrlKey && !e.altKey) {
                if (key === 's') { setTool && setTool('select'); return; }
                if (key === 'r') { setTool && setTool('rectangle'); return; }
                if (key === 'c') { setTool && setTool('circle'); return; }
                if (key === 'a') { setTool && setTool('arrow'); return; }
                if (key === 't') { setTool && setTool('text'); return; }
                if (key === 'n') { setTool && setTool('note'); return; }
            }

            // Удаление элементов
            if (key === 'delete' || key === 'backspace') {
                e.preventDefault();
                if (deleteSelectedElements) deleteSelectedElements();
                return;
            }

            // Выделить все (Ctrl/Cmd + A)
            if ((e.metaKey || e.ctrlKey) && key === 'a') {
                e.preventDefault();
                if (selectAll) selectAll();
                return;
            }

            // Копировать (Ctrl/Cmd + C)
            if ((e.metaKey || e.ctrlKey) && key === 'c') {
                e.preventDefault();
                if (copyElements) copyElements();
                return;
            }

            // Вставить (Ctrl/Cmd + V)
            if ((e.metaKey || e.ctrlKey) && key === 'v') {
                e.preventDefault();
                if (pasteElements) {
                    const pasted = pasteElements();
                    if (pasted && pasted.length > 0) {
                        setElements((prev) => [...prev, ...pasted]);
                        recordHistory('Вставка');
                    }
                }
                return;
            }

            // Вырезать (Ctrl/Cmd + X)
            if ((e.metaKey || e.ctrlKey) && key === 'x') {
                e.preventDefault();
                if (cutElements) cutElements();
                return;
            }

            // Переключить панель кода (Ctrl/Cmd + G)
            if ((e.metaKey || e.ctrlKey) && key === 'g') {
                e.preventDefault();
                setShowCodePanel((s) => !s);
            }
        };

        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [
        elements,
        selectedElementId,
        selectedElementIds,
        deleteSelectedElements,
        selectAll,
        copyElements,
        pasteElements,
        cutElements,
        setShowCodePanel,
        recordHistory,
        setElements,
        setTool,
        onSaveDiagram,
        onUndo,
        onRedo
    ]);
};
